<template>
	<div class="loading-overlay">
		<div class="overlay"></div>
		<LoadingWidget class="widget"/>
	</div>
</template>

<script>
export default {
	name: 'loading-overlay'
}
</script>

<style lang="stylus" scoped>
.loading-overlay
	width 100%
	height 100%

	position fixed
	top 0
	left 0
	z-index 10000

	&.fade-in-leave-active
		animation-duration 0.4s
	&.fade-in-enter-active
		animation none

	.overlay
		width 100%
		height 100%

		position absolute
		top 0
		left 0
		z-index 1
		
		background-color rgba(darker, 0.5)
	
	.widget
		width 4em
		height 4em

		position absolute
		top 50%
		left 50%
		z-index 2

		color light

		transform translate(-50%, -50%)
</style>